<template>
<div>
    <b-tabs>
        <b-tab :title="'Autorizações'">
            <template slot="title">
            <i class="fas fa-dollar-sign text-third"></i><span class="d-md-down-none pl-1 text-third"> Previsão de Gastos</span>
            </template>
            <div id="body-term">
            <HeadDetailsGama
            @setSing="setSing"
            :btnSing="this.dataDetails.situacao === -4"
            :btnNewRecibo="this.dataDetails.situacao !== 7 && this.dataDetails.situacao >= 0 &&this.dataDetails.motivoViagem.venda == true"
            :buttonsAccredited="true" @recibo="dowloadRecibo" @pdf="dowloadPdf"
            :btnNewPdf="this.dataDetails.situacao !== -4"
            :titleHead="'TERMO DE AUTORIZAÇÃO PARA REEMBOLSO DE VIAGEM'"
            @voltarPersonalizado="$emit('voltarPersonalizado')"
            :btnBack="true">
            </HeadDetailsGama>
            <div class="mt-4">
                <Tables ref="tableGrid"
                :columns="headTable"
                :showSearch="false"
                :showPrint="false"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad"
                    >
                        <tr v-for="obj in dataSpent" :key="obj.id">
                            <TableColumn :IsText="true" :status="obj.status" :value="obj.quantidade" />
                            <TableColumn :IsText="true" :status="obj.status" :value="obj.despesaTipo.nome" />
                            <TableColumn :IsText="true" :status="obj.status" :value="formatMoney(obj.valorUnitario)" />
                            <TableColumn :IsText="true" :status="obj.status" :value="formatMoney(obj.valorUnitario * obj.quantidade)" />
                        </tr>
                        <tr>
                            <td colspan="3"></td>
                            <td class="text-center total-table">TOTAL: {{ formatMoney(totalTable)}}</td>
                        </tr>
                </Tables>
            </div>
            </div>
        </b-tab>
        <b-tab :title="'Autorizações'">
            <template slot="title">
            <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Termos</span>
            </template>
            <div id="body-term">
                <HeadDetailsGama :buttonsAccredited="true" @setSing="setSing(0)"   :btnSing="this.dataDetails.situacao === -4" :btnNewPdf="this.dataDetails.situacao !==  -4"  @pdf="dowloadPdf" :titleHead="'TERMO DE AUTORIZAÇÃO PARA REEMBOLSO DE VIAGEM'"></HeadDetailsGama>
                <div class="d-flex justify-content-center">
                    <div id="card-description">
                        <p id="auto-font">Eu, {{dataDetails.favorecido.nome}} com o código {{dataDetails.favorecido.codigo}}, funcionário da empresa Zopone Engenharia e comércio Ltda, Autorizo a descontar na folha de pagamento a quantia de
                            {{formatMoney(dataDetails.valorSolicitado)}} referente á despesa de viagem.<br>
                            Período de viagem {{dataDetails.dataViagemInicioFormat}} a {{dataDetails.dataViagemFimFormat}}
                        </p>
                    </div>
                </div>
            </div>
        </b-tab>

        <b-tab :title="'Venda'" v-if="this.dataDetails.motivoViagem.venda == true">
            <template slot="title">
            <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Venda Baixada</span>
            </template>
            <div id="body-term">
                <HeadDetailsGama :buttonsAccredited="true" @setSing="setSing(1)" :btnNewRecibo="this.dataTermo.situacao !==  -4 && this.dataTermo.situacao !==  7 &&  this.dataDetails.motivoViagem.venda == true" @recibo="dowloadRecibo" :btnSing="this.dataTermo.situacao === 7"  :titleHead="'TERMO DE AUTORIZAÇÃO PARA VENDA BAIXADA'"></HeadDetailsGama>
                <div class="d-flex justify-content-center">
                    <div id="card-description">
                        <p id="auto-font">
                            Eu, {{dataDetails.favorecido.nome}} com o código {{dataDetails.favorecido.codigo}}, funcionário da empresa Zopone, solicito a venda da minha baixada na quantia
                            de {{formatMoney(dataDetails.valorSolicitado)}}. O valor solicitado é um acordo entre o empregado e o empregador, possui natureza indenizatória, e não será
                            incorporado ao salário para reflexos trabalhistas.
                            Período de viagem {{dataDetails.dataViagemInicioFormat}} a {{dataDetails.dataViagemFimFormat}}
                        </p>
                    </div>
                </div>
            </div>
        </b-tab>

        <b-tab :title="'Historico de viagem'">
            <template slot="title">
            <i class="fas fa-history text-third"></i><span class="d-md-down-none pl-1 text-third"> Historico de viagem</span>
            </template>
            <div id="body-term">
                <HeadDetailsGama :buttonsAccredited="true" :btnNewRecibo="this.dataDetails.situacao !==  -4 && this.dataDetails.motivoViagem.venda == true" @recibo="dowloadRecibo" @setSing="setSing" :btnSing="this.dataDetails.situacao === -4" :btnNewPdf="this.dataDetails.situacao !==  -4"  @pdf="dowloadPdf" :titleHead="'TERMO DE AUTORIZAÇÃO PARA REEMBOLSO DE VIAGEM'"></HeadDetailsGama>
                <div class="mt-4">
                <Tables ref="tableGridhistory"
                    :columns="headTerm"
                    :showSearch="false"
                    :showPrint="false"
                    :showDownload="false"
                    :showFullscreen="false"
                        >
                    <tr v-for="obj in dataDespesaHistory" :key="obj.id">
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.termoAnexoLog ? obj.termoAnexoLog.lote + ' Lote ' : 'N/D'" />
                        <TableColumn  :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataSolicitacao" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.solicitante ? obj.solicitante.nome : ''" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.favorecido ? obj.favorecido.nome : ''" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.obra ? obj.obra.referencia + ' - ' + obj.obra.localizacao : ''" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.responsavel ? obj.responsavel.nome : ''" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="formatMoney(obj.valorSolicitado)" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.motivoViagem ? obj.motivoViagem.nome : ''" />
                        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataViagemInicio" />
                        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataViagemFim" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="setFormaCityState(obj.cidadeOrigem)" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="setFormaCityState(obj.cidadeDestino)" />
                        <TableColumn :IsCustom="true" class="text-center">
                            <b-badge  v-if="(obj.situacao >= 0 && obj.situacao < 3) || obj.situacao === -4" variant="warning" pill style="padding: 6px 10px 6px 10px;">{{getStatus(obj.situacao)}}</b-badge>
                            <b-badge  v-if="obj.situacao >= 3" variant="success" pill style="padding: 6px 10px 6px 10px;">{{getStatus(obj.situacao)}}</b-badge>
                            <b-badge  v-if="obj.situacao < 0 && obj.situacao !== -4" variant="danger" pill style="padding: 6px 10px 6px 10px;">{{getStatus(obj.situacao)}}</b-badge>
                        </TableColumn>
                        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataAprovacao" />
                        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.aprovador ? obj.aprovador.nome : 'N/D'" />
                        <TableColumn :IsCustom="true" class="text-center">
                        <span v-if="obj.motivoReprovacao" v-b-tooltip.hover :title="obj.motivoReprovacao"><i class="fas fa-comment-alt" style="font-size: 15px; color: #ff0000;"></i></span>
                        <span>&nbsp;</span>
                        </TableColumn>
                        <TableColumn :IsCustom="true" class="text-center">
                        <span class="text-third" v-if="obj.situacao === 3" v-b-tooltip.hover :title="'Clonar'" @click="onClone(obj)"><i class="fa fa-clone icone-grid"></i></span>
                        </TableColumn>
                    </tr>
                </Tables>
                </div>
            </div>
        </b-tab>
        <b-tab :title="'Log'">
        <template slot="title">
            <i class="fas fa-tasks text-third"></i><span class="d-md-down none pl-1 text-third text-tabs"> Log </span>
        </template>
        <div class="painel-detalhes-main" id="body-term">
            <HeadDetailsGama :buttonsAccredited="true" @setSing="setSing" :btnSing="this.dataDetails.situacao === -4" :btnNewPdf="this.dataDetails.situacao !==  -4"  @pdf="dowloadPdf" :titleHead="'Log de Status'"></HeadDetailsGama>
            <div id="body-details">
                <div id="head-details" class="pt-2">
                    <div class="w-25 input-rela icon-adjustment">
                        <input placeholder="Pesquisar log" class="form-control input-paddi w-100 h-100" v-model="serachiput" >
                        <i aria-hidden="true" class="fas fa-search icon-search"></i>
                    </div>
                </div>
            </div>
            <div id="body-details">
            <div id="tablog" class="mt-4 ml-2">
            <div v-if="serachiput.length == ''">
                <div v-for="(data,index) in logAdvance" :key="data.id">
                    <div class="d-flex flex-row mt-1 ml-2" style="font-family:'Segoe UI'">
                        <div class="linhaAling">
                            <div class="ballCrzy">
                                <div class="textNum">{{data.diaFormatada}}</div>
                                <div class="textNum">{{mostrarNomeMes(data.mesFormatada)}}</div>
                            </div>
                            <div class="linhaSolid"></div>
                        </div>
                        <div class ="ml-3 mt-3">
                            <div class="squareCrzy">
                                <div class="Textneg"> {{data.titulo}} </div>
                                <div class="Textneg2">
                                    <div class="description-log">
                                        <i class="fas fa-user-circle" style="scale: 1.25" ></i>{{data.nomeConta != null ? data.nomeConta : 'N/D'}}
                                    </div>
                                    <div class="description-log">
                                        <i class="far fa-clock" style="scale: 1.25"></i>{{data.dataFormatada}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="index == logAdvance.length -1">
                        <div class="d-flex flex-row mt-1 ml-2">
                            <div class="linhaAling">
                                <div class="ballCrzy">
                                    <div class="fas fa-check ballCrzyDone"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    <div v-if="logAdvance.length < 1" class="d-flex flex-row mt-1 ml-2">
                        <div class="d-flex align-items-center w-100 h-100 flex-row mt-1" style="font-family:'Segoe UI'">
                            <div class="linhaAling mr-3">
                                <div class="ballCrzy">
                                    <div class="fas fa-question ballCrzyDone"></div>
                                </div>
                                <!-- <div class="linhaSolid"></div> -->
                            </div>
                            <!-- <div class ="ml-3 mt-3">
                                <div class="squareCrzy"> -->
                                    <div class="Textneg"> Nenhum registro de log foi encontrado! </div>
                                <!-- </div>
                                </div> -->
                        </div>
                    </div>
                <!-- <div v-if="data.length !== null || serachiput.length !== 0" class="d-flex align-items-center flex-row mt-1 ml-2 w-100 h-100">
                    <div class="linhaAling">
                        <div class="ballCrzy">
                            <div class="fas fa-check ballCrzyDone"></div>
                        </div>
                    </div>
                </div> -->
                </div>
            </div>
        </div>
            <!-- <logAdvance :buttonsAccredited="true" @setSing="setSing" :btnSing="this.dataDetails.situacao === -4" :btnNewPdf="this.dataDetails.situacao !==  -4"  ref="logAdvance"></logAdvance> -->
        </div>
    </b-tab>
    </b-tabs>
    <b-modal
        hide-footer
        :title="'Assinatura'"
        centered
        size="xl"
        ref="add-sign"
        id="add-sign">
        <div >
            <div class="d-flex justify-content-center mt-2">
                <button class="btn-dowload" @click="print()"><i class="fas fa-file-pdf"></i> BAIXAR PDF</button>
            </div>
            <div class="d-flex justify-content-center mt-2">
                <div v-if="!hasFile" class="input-import" @click="addImg">
                    <div>
                        <div class="d-flex justify-content-center mb-3">
                            <i class="fas fa-cloud-download-alt" style="font-size: 80px"></i>
                        </div>
                        <p id="font-pdf">Baixe o PDF acima,adicione a assinatura e insira aqui o documento assinado!</p>
                    </div>
                </div>
                <div v-else class="input-with-file">
                    <div @click="removeFile" id="remove-file">X</div>
                    <i class="fas fa-file-pdf" style="font-size: 80px;color: #028849"></i>
                    <div id="footer-file">{{nameFile}}</div>
                </div>
            </div>
             <div class="d-flex justify-content-center mt-3">
                <button @click="closeModalCan" class="btn-cancel mr-1">CANCELAR</button>
                <button class="btn-send ml-1" @click="sendSign">ENVIAR</button>
            </div>
            <input type="file" @change="setValueInput" style="visibility:hidden" id="input-hidden" accept="application/pdf  ">
        </div>
    </b-modal>
</div>
</template>

<script>
import FormDetailsAdvance from './FormDetailsAdvance'
export default FormDetailsAdvance
</script>

<style scoped>
#auto-font{
    font-size: 16px;
    line-height: 1.5;
    font-weight: bold;
}
#card-description{
    width: 98%;
    height: 250px;
    padding: 20px;
    margin-top: 25px;
    border-radius: 10px;
    border: 1px solid rgb(180, 180, 180);
}
.close-modal{
    height: 45px;
    width: 45px;
    position: absolute;
    right: 15px;
    background: rgb(247, 9, 9);
    border: none;
    font-size: 24px;
    color: white;
    font-weight: bold;
    border-radius: 50%;
}
.close-modal:hover{
    background: rgb(129, 3, 3);
}
#remove-file{
    height: 65px;
    width: 65px;
    border-radius: 0 10px 0 50%;
    top: 0;
    right: 0;
    position: absolute;
    color: white;
    font-size: 24px;
    font-weight: bold;
    background: red;
    display: flex;
    justify-content: center;
    align-items: center;
}
.head-modal{
    background: #025e33;
    height: 50px;
    color: white;
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
}
.modal-body{
    padding: 0px !important;
}
#remove-file:hover{
    background: rgb(182, 1, 1);
}
#footer-file{
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    color: white;
    background: #028849;
    border-radius: 0 0 10px 10px;
    font-size: 24px;
    width: 100%;
}

.btn-cancel {
    width: 20%;
    height: 45px;
    border: none;
    background: #cacaca;
    border-radius: 10px;
    color: white;
    font-size: 16px;
}

.btn-send {
    width: 20%;
    height: 45px;
    border: none;
    background: #025e33;
    border-radius: 10px;
    color: white;
    font-size: 16px;
}

.btn-send:hover{
    background: #028849;

}
.btn-dowload{
    width: 40%;
    height: 45px;
    border: none;
    background: #025e33;
    border-radius: 10px;
    color: white;
    font-size: 16px;
}
.btn-dowload:hover{
    background: #028849;

}

.input-import{
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 350px;
    border-radius: 10px;
    border: 1px dashed black;
}
#font-pdf{
    font-size: 20px;
    text-align: center;
    font-weight: bold;
}
.input-with-file{
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 350px;
    position: relative;
    border-radius: 10px;
    border: 1px solid #028849;
}
#body-term{
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 70vh;
    /* border: 1px solid rgb(180, 180, 180); */
    border-radius: 10px;

}
.total-table{
    border: 1px solid rgb(219, 219, 219);
    color: #025e33;
    font-weight: bold;
}

#greenChange {
    color: #008148;
}

.ballCrzy {
    width: 50px;
    height: 50px;
    border-radius:50%;
    border: 3px solid;
    font-size: 16px;
}

.ballCrzyDone {
    display: flex;
    justify-content: center;
    padding-top: 13px;
    font-size: 20px;
}

.squareCrzy {
    width: 520px;
    height: 150px;
    background: rgb(243, 241, 241);
    border-radius:1px 15px 15px;
    color: #111;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1rem 1rem 1rem 2rem;
    box-shadow: 10px 10px 5px 0px #d2d2d2;
    font-family: 'Segoe UI';
    display: flex;
    justify-content: space-between;
}

.textNum{
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}

.Textneg2 {
    font-size: 12px;
    color:rgb(116, 121, 116);
    font-family:'Segoe UI';
    font-weight: bold;
    display: flex;
    flex-direction: column;
}

.Textneg {
    font-weight: bold;
    font-size: 17px;
    color:#008148;
}

.linhaSolid {
    height: 125px;
    border-left: 2px solid;
}

.icon-adjustment {
    display: flex;
    flex-direction: row-reverse;
    align-items: baseline;
    border: 1px solid #ced4da;
    padding-left: 5px;
}

.form-control{
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px none;
    border-radius: 0;
    padding-left: 5px;
}

.linhaAling{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    color: #008148;
}

#tablog{
    height: 100%;
}

.description-log {
    display: flex;
    gap: 1rem;
    font-family:'Segoe UI';
    align-items: center;
}
/* AAAAAA */

.check-patologia-td{
    height: 25px;
    min-height: 25px;
    max-height: 25px;
}
.main-container{
    position: relative;
}
.painel-detalhes-main{
    height: 73vh;
    overflow: auto;
    font-family: 'Segoe UI';
}

.painel-detalhes-main::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 15px;
}
.painel-detalhes-main::-webkit-scrollbar {
    width: 10px;
    height: 10px;
     border-radius: 9px;
    background: #F4F4F4;
}
.painel-detalhes-main::-webkit-scrollbar-thumb {
    background: rgb(192, 193, 192);
    border-radius: 9px;
}

/* PDF */
.container-pdf{
    padding: 3px 20px 5px 20px;
}
.table-pdf{
    border: 1px solid black;
    width: 100%;
}
.assinatura-body{
    margin-top: 60px;
}
.testechek{
 accent-color: green;
}
.pdf-header{
    height: 7vh;
    display: flex;
    align-items: center;
    padding-left: 25px;
    background: #e4e5e6;
}

.codigoposition{
    padding-left: 685px;
    /* display: flex;
    height: 100%;
    width: 100%;
    justify-content: end;
    align-items: center; */
}

.sub-title{
    font-weight: bold;
    margin-bottom: 5px;
    margin-top: 25px;
}
.td-tratamento{
    min-height: 25px;
    max-height: 25px;
    height: 25px;
    padding-left: 15px;
    border: 1px solid gray;
    width: 100%;
}
.assinatura-row{
    width: 100%;
    height: 2px;
    background: gray;
}
.table-pdf-td{
    border: 1px solid gray;
    width: 50%;
    padding-left: 10px;
    min-height: 25px;
    height: 25px;
    max-height: 25px;
}
.td-avaliacao-cl{
    width: 60%;
    min-height: 25px;
     height: 25px;
    max-height: 25px;
    padding-left: 10px;
    border: 1px solid gray;
}
.size-logo-inco-pdf{
    height: 50px;
    width: 250px;
}
.td-availiacao-check{
    width: 10%;
    height: 25px;
    min-height: 25px;
    max-height: 25px;
    padding-left: 10px;
    border: 1px solid gray;
}
.check-table
{
    height: 15px;
    display: flex;
    align-items: center;
}
.heigth-empty-col
{
    height: 25px;
    min-height: 25px;
    max-height: 25px;

}
.dataandhour{
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-right: 25px;
}

@media (min-width: 1281px) and (max-width: 1400px)
{

    .painel-detalhes-main{
        height: 70vh;
        overflow: auto;
        font-family: 'Segoe UI';
    }
}
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/FormDetailsAdvance/FormDetailsAdvance.vue